import React from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import CustomButton, { ICustomButtonProps } from "./CustomButton";
import { COLORS } from "../../assets/theme";

interface ButtonsRowProps {
  buttons: ICustomButtonProps[];
}

const ButtonsRow: React.FC<ButtonsRowProps> = ({ buttons }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        padding: 3,
        borderRadius: 2,
        backgroundColor: COLORS.textPrimary,
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: isSmallScreen ? "8px" : "16px",
      }}
    >
      {buttons.map((button, index) => (
        <Box
          key={`button-${index}`}
          sx={{
            flex: isSmallScreen ? "1 1 100%" : "0 0 auto",
            display: "flex",
            justifyContent: isSmallScreen ? "center" : "flex-start",
          }}
        >
          <CustomButton
            {...button}
            sx={{
              ...button.sx,
              padding: "10px",
            }}
          />
        </Box>
      ))}
    </Box>
  );
};

export default ButtonsRow;
